import {DOM} from "../../../../../../public/js/utils/DOM";
import {FormValidator} from "../../../../../../public/js/utils/Validator/FormValidator";
import {ControlsForm} from "../../../../Form/Form";

export namespace ControlsWelcomeRegisterRegisterControl {

    class Config {
        public static readonly registerFormId = 'register-form';
        public static readonly registerFormSubmitId = 'register-form-submit';
        public static readonly registerBackendCallback = "Register";
        public static readonly control = "register";
    }

    export class Loader {

        public static load() : void {
            this.initRegisterForm();
        }

        public static initRegisterForm() : void {

            const formElement = DOM.Parser.getHtmlElement(Config.registerFormId) as HTMLFormElement;
            const submitButton = DOM.Parser.getHtmlElement(Config.registerFormSubmitId) as HTMLInputElement;
            FormValidator.validateForm({form: formElement, forceSubmitButton: submitButton});

            submitButton.addEventListener('click', (event: MouseEvent) => {

                void ControlsForm.Controller.sendFormDataRequest(formElement, {
                    linkParameters: {component: Config.control, method: Config.registerBackendCallback, parameters: []},
                    formData: ControlsForm.Controller.getFormData(formElement),
                    forceDisabledButtons: [submitButton],
                    event: event,
                    successCallback: () => {
                        this.initRegisterForm();
                    }
                })
            });
        }
    }
}